import _ from 'lodash';

export const isWaitlist = application => !!_.get(getCreatorAppliation(application), 'waitlistObject.id');
export const getCreatorAppliation = application => _.get(application, 'creatorApplication', {});
export const getCreatorAppliationWaitlistObject = application => _.get(getCreatorAppliation(application), 'waitlistObject', {});
export const getCreatorApplicationConnectedInstagram = application => _.get(getCreatorAppliation(application), 'instagramAccount', {});
export const getCreatorApplicationConnectedYoutube = application => _.get(getCreatorAppliation(application), 'youtubeAccount', {});
export const getCreatorApplicationConnectedTiktok = application => _.get(getCreatorAppliation(application), 'tiktokAccount', {});
